import { useMemo } from 'react';

import { useWorkspaceJoinRequestListQuery } from './WorkspaceJoinRequestListQuery.generated';

export const useWorkspaceJoinRequestList = ({
  orgId,
  skip = false,
}: {
  orgId: string;
  skip?: boolean;
}) => {
  const { data, loading, error } = useWorkspaceJoinRequestListQuery({
    variables: {
      orgId,
    },
    waitOn: ['None'],
    skip,
  });

  const accessRequests = useMemo(
    () => data?.organization?.accessRequests || [],
    [data?.organization?.accessRequests],
  );

  return {
    accessRequests,
    requestMemberCount: accessRequests.length,
    loading,
    error,
  };
};
